module.exports = __webpack_public_path__ + "static/media/soy bean.c093c9a7.jpg";